import { createMiddleware } from "@tanstack/react-start";
import { trackSsrInvocation } from "@/lib/infra-metering";

function isSsrDocumentRequest(pathname: string, method: string): boolean {
  if (method !== "GET") return false;
  if (pathname.startsWith("/api/")) return false;
  if (pathname.startsWith("/assets/")) return false;
  if (/\.[a-z0-9]+$/i.test(pathname)) return false;
  return true;
}

export const infraMeteringMiddleware = createMiddleware().server(async ({ request, next }) => {
  const url = new URL(request.url);
  if (isSsrDocumentRequest(url.pathname, request.method)) {
    void trackSsrInvocation();
  }
  return next();
});
